import { useEffect, useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { useLanguage } from "../../context/LanguageContext";
import { FollowBreederButton } from "./FollowBreederButton";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { UpdatePost } from "../LitterUpdatePost";
import { UpdateReactions } from "../LitterUpdateReactions";

export function LitterUpdatesFeed({ litter, onClose }) {
  const { t, lang } = useLanguage();
  const [data, setData] = useState(null);
  const load = () => api.get(`/litters/${litter.id}/updates`).then((r) => setData(r.data)).catch(() => setData({ locked: true, items: [] }));
  useEffect(() => {
    if (!litter) return;
    setData(null);
    load();
  }, [litter]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Dialog open={!!litter} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto bg-white" data-testid="litter-feed-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-[#12234A]">{t("lu_view")}</DialogTitle>
          <DialogDescription className="text-slate-500">{litter?.title || litter?.breed}</DialogDescription>
        </DialogHeader>
        {!data ? <div className="flex justify-center py-8"><Loader2 className="animate-spin text-[#F5551E]" /></div> : data.locked ? (
          <div className="rounded-xl bg-purple-50 border border-purple-200 p-5 text-center" data-testid="litter-feed-locked">
            <Lock size={22} className="mx-auto text-purple-500" />
            <p className="text-sm text-purple-900 mt-2">{t("lu_locked")}</p>
            <div className="mt-3 flex justify-center"><FollowBreederButton breederId={litter.breeder_id} onChange={(d) => d.following && load()} /></div>
          </div>
        ) : data.items.length === 0 ? <p className="text-sm text-slate-400 py-6 text-center">{t("lu_none")}</p> : (
          <div className="space-y-3" data-testid="litter-feed">{data.items.map((u) => <UpdatePost key={u.id} u={u} lang={lang} footer={<UpdateReactions update={u} />} />)}</div>
        )}
      </DialogContent>
    </Dialog>
  );
}
